<template>
    <b-container id="global-search-bar-container">
        <b-row>
            <b-col>
                <div id="global-search-bar">
                    <button id="burger_button" v-if="isMobile" @click="openGlobalDrawer">
                        <b-icon icon="list" aria-hidden="true"></b-icon>
                    </button>
                    <b-form-input :value="localSearchFilter" :placeholder="$t('recherche_label')"
                        @input="onSearchInput"></b-form-input>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
const SEARCH_DEBOUNCE_MS = 300;

export default {
    data() {
        return {
            localSearchFilter: "",
            searchDebounceTimer: null,
        };
    },
    computed: {
        ...mapState("ui", ["globalSearchFilter"]),
        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    watch: {
        globalSearchFilter(value) {
            if (value !== this.localSearchFilter) {
                this.localSearchFilter = value;
            }
        },
    },
    created() {
        this.localSearchFilter = this.globalSearchFilter;
    },
    beforeDestroy() {
        clearTimeout(this.searchDebounceTimer);
    },
    methods: {
        ...mapActions("ui", ["openGlobalDrawer", "updateGlobalSearchFilter"]),
        onSearchInput(nextValue) {
            this.localSearchFilter = nextValue;
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.updateGlobalSearchFilter(nextValue);
            }, SEARCH_DEBOUNCE_MS);
        },
    }

}
</script>
<style lang="scss" scoped></style>
